import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';

@Component({
  selector: 'app-cfo-quote-details',
  templateUrl: './cfo-quote-details.component.html',
  styleUrls: ['./cfo-quote-details.component.scss']
})
export class CfoQuoteDetailsComponent implements OnInit {
  json:any=[]
  clientData:any = {}
  clientName:any=[];
  cfoQuote;
  constructor( private router:Router,
    public httpService:HttpServiceService, public alertService:AlertService,
    public util:UtilService,
    public loaderService:LoaderService) {
    this.cfoQuote = JSON.parse(localStorage.getItem('cfoQuoteDetails'))
  }

  ngOnInit() {
    this.clientData =  JSON.parse(localStorage.getItem('AlluserData'))
this.getQuoteVersion(this.cfoQuote.id);
this.httpService.postApi(this.cfoQuote.client, 'Client/getbyid/' + this.cfoQuote.client).subscribe((res: any) => {
  if (res.success) {
    console.log(res)
    this.clientName=res.success.client[0];
  }
});
  }

  toggleStatus(id,status){
    let data={
      isAvailable:status
    }
    this.loaderService.showLoader('Updating Please wait ..').then(()=>{
      try{
        this.httpService.postApi(data, 'Cfoquote/edit' + id).subscribe((res: any) => {
          this.loaderService.hideLoader();
          if (res["success"]) {
            this.alertService.presentAlert('Success','Successfully updated','Okay');
            this.router.navigate(['/cfoQuote-list'])
          } else {
            this.alertService.presentAlert('Error',res["error"]["message"],'Okay');
          }
        },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });    
      }catch(e){
        this.loaderService.hideLoader();
        this.alertService.presentAlert('Error','Something went wrong please try again','Okay');
      }
    })
  }

  delete(data) {
    this.loaderService.showLoader('Updating Please wait ..').then(()=>{
      try{
        this.httpService.postApi(data, 'Cfoquote/remove/'+data.id).subscribe((res: any) => {
          this.loaderService.hideLoader();
          if (res["success"]) {
            this.alertService.presentAlert('Success','Successfully deleted','Okay');
            this.router.navigate(['/cfoQuote-list'])
          } else {
            this.alertService.presentAlert('Error',res["error"]["message"],'Okay');
          }
        },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });    
      }catch(e){
        this.loaderService.hideLoader();
        this.alertService.presentAlert('Error','Something went wrong please try again','Okay');
      }
    })

  }
  edit(data) {
    console.log(data)
    localStorage.setItem('editData', JSON.stringify(data));
    this.router.navigate(['/cfoQuote-edit'])
  }

  // download(data)
  // {
  //   window.open(this.httpService.serverUrl+'Ecquote/test/' +data.id,'_blank')
  // }

  getQuoteVersion(data)
  {
 
          this.httpService.postApi(data, 'Cfoquote/getvesions/' + data).subscribe((res: any) => {
            if (res.success) {
              console.log(res)
               this.json = res.success.versions
              
            }
          });
    
   
  }
}
